import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./RestrictionLastBanner.css";
import Heading from "../../../utls/Heading";
const RestrictionLastBanner = () => {
  return (
    <>
      <div className="last-banner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-white">
              <Heading className="customheadings">
                <span className="last-banner-span">Need</span> More Information?
              </Heading>
              <p>
                Reach out for personalized assistance on your travel
                destination!
              </p>
              <div className="carouselCaption restriction">
                <a href="/consultation">
                  <button className="btn bg-transparent text-white mt-md-3 grotesk-headings fw-bold">
                    Consultation Services
                  </button>
                </a>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="rest-last-banner-img">
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/images/restrictionLastBanner.png"
                  alt=""
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RestrictionLastBanner;
